import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  fill?: string;
};

const Wave = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 343 127"
    ref={ref}
    {...props}
  >
    <path
      d="M202.771 36.8216C280.813 69.7335 342.143 66.3895 359.373 67.7743L359.373 126.86L-17.0386 126.86L-17.0386 9.61181C66.6239 -8.39085 110.535 -2.0762 202.771 36.8216Z"
      fill="#EBFDF5"
    />
  </svg>
));

export default Wave;
